import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home/Home";
import About from "./pages/About";
import Alumni from "./pages/Alumni"; // Import the Alumni page
import Events from "./pages/Events/Events";
import Articles from "./pages/Articles/Articles";
import Contact from "./pages/Contact";
import DetailsArticlePage from "./pages/Articles/DetailsArticlePage";
import DetailsEventPage from "./pages/Events/DetailsEventPage";
import AdminPage from "./pages/Admin/AdminPage";
import { ArticlesProvider } from "./contexts/ArticlesContext";
import { EventsProvider } from "./contexts/EventsContext";


function App() {
  return (
    <ArticlesProvider>
    <EventsProvider>
         <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/alumni" element={<Alumni />} /> {/* New route for Alumni */}
            <Route path="/events" element={<Events />} />
            <Route path="/events/:id" element={<DetailsEventPage />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:id" element={<DetailsArticlePage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/adminpage" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router> 
    </EventsProvider>
    </ArticlesProvider>

  );
}

export default App;
